import { render, staticRenderFns } from "./createBatch.vue?vue&type=template&id=9a8ce5b2&scoped=true"
import script from "./createBatch.vue?vue&type=script&lang=js"
export * from "./createBatch.vue?vue&type=script&lang=js"
import style0 from "./createBatch.vue?vue&type=style&index=0&id=9a8ce5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8ce5b2",
  null
  
)

export default component.exports